import { render } from "./LeadsList.vue?vue&type=template&id=b239d9bc&scoped=true"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"

import "./LeadsList.vue?vue&type=style&index=0&id=b239d9bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b239d9bc"]])

export default __exports__